import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';

    // Class Definition
    OndigoNS.TeaserSlider = function (element) {
        var that = this;

        this.$teaserSlider = $(element);
        this.$slides = $('.slide', this.$teaserSlider);
        this.$slideDescriptions = $('.locationDescription', this.$teaserSlider);
        this.$slidesWrapper = $('.slidesWrapper', this.$teaserSlider);
        this.$sliderOverflow = $('.sliderOverflow', this.$teaserSlider);
        this.$slideLeftButton = $('.onIconArrowCircleLeft', this.$teaserSlider);
        this.$slideRightButton = $('.onIconArrowCircleRight', this.$teaserSlider);

        this.$window = $(window);

        this.slideCount = this.$slides.length;
        this.imageWidth = this.$slides.width();

        this.currentSlide = 0;
        this.currentState = OndigoNS.Utils.getCurrentState();
        this.visibleImages = 3;

        this.smallVersion = false;

        this.teaserSpace = 50;

        that.init();
    };

    OndigoNS.TeaserSlider.prototype = {
        init: function () {
            var scope = this;

            if (this.slideCount < 4) {
                this.$teaserSlider.addClass('smallVersion');
                this.$slideRightButton.hide();
                this.smallVersion = true;
            }
            else {
                this.$slideLeftButton.on('click', function() {
                    scope.slide('left');
                });
                this.$slideRightButton.on('click', function() {
                    scope.slide('right');
                });
            }
            this.updatePositions();
            this.updateDescriptionHeight();

            this.$window.on('resize', function () {
                var stateBefore = scope.currentState;
                scope.currentState = OndigoNS.Utils.getCurrentState();

                if (stateBefore !== scope.currentState) {
                    window.setTimeout(function() {
                        scope.updatePositions();
                    }, 100);
                    if (OndigoNS.Utils.getWindowInnerWidth() >= OndigoNS.breakpointMax) {
                        scope.$slideRightButton.show();
                    }
                }
                scope.updateDescriptionHeight();
                if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointMax) {
                    scope.$slideLeftButton.attr('style', '');
                    scope.$slideRightButton.attr('style', '');
                    scope.$slidesWrapper.attr('style', '');
                    scope.currentSlide = 0;
                }
                else {
                    if (scope.slideCount < 4) {
                        scope.$slideRightButton.hide();
                    }
                }
            });
        },
        updateDescriptionHeight : function() {
            var heights = [],
                maxHeight;

            // add all heights to the array
            $.each(this.$slideDescriptions, function () {
                $(this).css('height','');
                heights.push($(this).height());
            });

            // get the highest height in the array
            maxHeight = OndigoNS.Utils.maxValueInArray(heights);

            // assign the highest height to all elements
            $.each(this.$slideDescriptions, function () {
                $(this).height(maxHeight);
            });
        },
        updatePositions : function() {
            var xPos = 0,
                space = this.teaserSpace;

            if (this.smallVersion) {
                space = 100;
            }

            if (OndigoNS.Utils.getWindowInnerWidth() > OndigoNS.breakpointWide) {
                $.each(this.$slides, function() {
                    $(this).css('left', xPos + 'px');
                    xPos = xPos + $(this).width() + space;
                });
            }
        },
        slide: function (direction) {
            if (direction === 'left' && this.currentSlide !== 0) {
                this.currentSlide--;
                if (this.currentSlide === 0) this.$slideLeftButton.hide();
                this.$slideRightButton.show();
            }
            else if (direction === 'right' && this.currentSlide !== this.slideCount - this.visibleImages) {
                this.currentSlide++;
                if (this.currentSlide === this.slideCount - this.visibleImages) this.$slideRightButton.hide();
                this.$slideLeftButton.show();
            }

            this.$slidesWrapper.css('margin-left', this.currentSlide * (this.imageWidth+this.teaserSpace)*-1);
        }
    };

    // plugin definition
    $.fn.teaserSlider = function () {
        return new OndigoNS.TeaserSlider(this);
    };
    $.fn.teaserSlider.Constructor = OndigoNS.TeaserSlider;

}(window.jQuery));


$(document).ready(function () {
    'use strict';

    var $slider = $('.teaserSlider');

    if ($slider.length) {
        $.each($slider, function () {
            $(this).teaserSlider();
        });
    }
});